var _circle, _circle2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 87,
    viewBox: "0 0 89 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.0886,
    cy: 56.9321,
    r: 30.0681,
    fill: "#AFFFD1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9116,
    cy: 30.9118,
    r: 28.9116,
    stroke: "#16161E",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 12.8233,
    y2: -2,
    transform: "matrix(0.715187 0.698933 -0.715187 0.698933 18.1906 30.2678)",
    stroke: "#16161E",
    strokeWidth: 4,
    strokeLinecap: "square"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 21.9581,
    y2: -2,
    transform: "matrix(0.715187 -0.698933 0.715187 0.698933 28.9003 40.7178)",
    stroke: "#16161E",
    strokeWidth: 4,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a29c60ff5a5654432dc35ca5efeba02e.svg";
export { ForwardRef as ReactComponent };